/**
 * Created by Kieran on 04/06/2017.
 */

import axios from 'axios'
import config from '../../config/index'


/**
 * GraphApi
 * @type {{getMoodGraph: (function(*=, *=, *=): AxiosPromise), getMedicationGraph: (function(*=, *=, *=, *=): AxiosPromise), getSleepGraph: (function(*=, *=, *=): AxiosPromise), getBloodGlucoseGraph: (function(*=, *=, *=): AxiosPromise), getBloodPressureGraph: (function(*=, *=, *=): AxiosPromise), getWeightGraph: (function(*=, *=, *=): AxiosPromise), getInsulinGraph: (function(*=, *=, *=): AxiosPromise), getKetonesGraph: (function(*=, *=, *=): AxiosPromise), getNutritionGraph: (function(*=, *=, *=, *=): AxiosPromise)}}
 */
let GraphApi = {
  CancelToken: axios.CancelToken,
  Cancel: null,

  getHeartRateGraph: function (params = {limit: 500, skip: 0}) {
    let self = this;
    return axios.get(config.apiUrl + 'graph/heartRate/', {
      params: params,
      cancelToken: new self.CancelToken(function executor(c) {
        self.Cancel = c;
      })
    });
  },
  /**
   * @param fromDate
   * @param toDate
   * @param userId
   * @returns {AxiosPromise}
   */
  getActivityGraph: function (fromDate, toDate, userId) {
    let self = this;
    return axios.get(config.apiUrl + 'graph/activity/', {
      params: {
        fromDate: fromDate,
        toDate: toDate,
        user_id: userId,
      },
      cancelToken: new self.CancelToken(function executor(c) {
        self.Cancel = c;
      })
    })
  },
  /**
   *
   * @param fromDate
   * @param toDate
   * @param userId
   * @param type
   * @returns {AxiosPromise}
   */
  getActivityStepsGraph: function (fromDate, toDate, userId, type) {
    let self = this;
    return axios.get(config.apiUrl + 'graph/activity/steps/', {
      params: {
        fromDate: fromDate,
        toDate: toDate,
        user_id: userId,
        type: type
      },
      cancelToken: new self.CancelToken(function executor(c) {
        self.Cancel = c;
      })
    })
  },

  /**
   * @param fromDate
   * @param toDate
   * @param userId
   * @returns {AxiosPromise}
   */
  getMoodGraph: function (fromDate, toDate, userId) {
    let self = this;
    return axios.get(config.apiUrl + 'graph/moods/', {
      params: {
        fromDate: fromDate,
        toDate: toDate,
        user_id: userId,
      },
      cancelToken: new self.CancelToken(function executor(c) {
        self.Cancel = c;
      })
    })
  },
  /**
   *
   * @param fromDate
   * @param toDate
   * @param userId
   * @param medTrackingId
   * @returns {AxiosPromise}
   */
  getMedicationGraph: function (fromDate, toDate, userId, medTrackingId) {
    let self = this;
    return axios.get(config.apiUrl + 'graph/medications/', {
      params: {
        fromDate: fromDate,
        toDate: toDate,
        user_id: userId,
        tracking_id: medTrackingId
      },
      cancelToken: new self.CancelToken(function executor(c) {
        self.Cancel = c;
      })
    })
  },
  /**
   *
   * @param fromDate
   * @param toDate
   * @param userId
   * @returns {AxiosPromise}
   */
  getSleepGraph: function (fromDate, toDate, userId) {
    let self = this;
    return axios.get(config.apiUrl + 'graph/sleep/', {
      params: {
        fromDate: fromDate,
        toDate: toDate,
        user_id: userId,
      },
      cancelToken: new self.CancelToken(function executor(c) {
        self.Cancel = c;
      })
    })
  },
  /**
   *
   * @param fromDate
   * @param toDate
   * @param userId
   * @param type
   * @returns {AxiosPromise}
   */
  getSleepWearableGraph: function (fromDate, toDate, userId, type) {
    let self = this;
    return axios.get(config.apiUrl + 'graph/sleep/wearable/', {
      params: {
        fromDate: fromDate,
        toDate: toDate,
        user_id: userId,
        type: type
      },
      cancelToken: new self.CancelToken(function executor(c) {
        self.Cancel = c;
      })
    })
  },
  /**
   *
   * @param fromDate
   * @param toDate
   * @param userId
   * @returns {AxiosPromise}
   */
  getBloodGlucoseGraph: function (fromDate, toDate, userId) {
    let self = this;
    return axios.get(config.apiUrl + 'graph/blood-glucose/', {
      params: {
        fromDate: fromDate,
        toDate: toDate,
        user_id: userId
      },
      cancelToken: new self.CancelToken(function executor(c) {
        self.Cancel = c;
      })
    })
  },
  getHba1cGraph: function (fromDate, toDate, userId) {
    let self = this;
    return axios.get(config.apiUrl + 'graph/hba1c/', {
      params: {
        fromDate: fromDate,
        toDate: toDate,
        user_id: userId
      },
      cancelToken: new self.CancelToken(function executor(c) {
        self.Cancel = c;
      })
    })
  },
  /**
   *
   * @param fromDate
   * @param toDate
   * @param userId
   * @returns {AxiosPromise}
   */
  getCholesterolGraph: function (fromDate, toDate, userId) {
    let self = this;
    return axios.get(config.apiUrl + 'graph/cholesterol/', {
      params: {
        fromDate: fromDate,
        toDate: toDate,
        user_id: userId
      },
      cancelToken: new self.CancelToken(function executor(c) {
        self.Cancel = c;
      })
    })
  },
  /**
   *
   * @param fromDate
   * @param toDate
   * @param userId
   * @returns {AxiosPromise}
   */
  getBloodPressureGraph: function (fromDate, toDate, userId) {
    let self = this;
    return axios.get(config.apiUrl + 'graph/blood-pressure/', {
      params: {
        fromDate: fromDate,
        toDate: toDate,
        user_id: userId
      },
      cancelToken: new self.CancelToken(function executor(c) {
        self.Cancel = c;
      })
    })
  },
  /**
   *
   * @param fromDate
   * @param toDate
   * @param userId
   * @returns {AxiosPromise}
   */
  getWeightGraph: function (fromDate, toDate, userId) {
    let self = this;
    return axios.get(config.apiUrl + 'graph/weight/', {
      params: {
        fromDate: fromDate,
        toDate: toDate,
        user_id: userId
      },
      cancelToken: new self.CancelToken(function executor(c) {
        self.Cancel = c;
      })
    })
  },
  getWaistGraph: function (fromDate, toDate, userId) {
    let self = this;
    return axios.get(config.apiUrl + 'graph/waist-hip/', {
      params: {
        fromDate: fromDate,
        toDate: toDate,
        user_id: userId
      },
      cancelToken: new self.CancelToken(function executor(c) {
        self.Cancel = c;
      })
    })
  },
  /**
   *
   * @param fromDate
   * @param toDate
   * @param userId
   * @returns {AxiosPromise}
   */
  getInsulinGraph: function (fromDate, toDate, userId) {
    let self = this;
    return axios.get(config.apiUrl + 'graph/insulin/', {
      params: {
        fromDate: fromDate,
        toDate: toDate,
        user_id: userId
      },
      cancelToken: new self.CancelToken(function executor(c) {
        self.Cancel = c;
      })
    })
  },
  /**
   *
   * @param fromDate
   * @param toDate
   * @param userId
   * @returns {AxiosPromise}
   */
  getKetonesGraph: function (fromDate, toDate, userId) {
    let self = this;
    return axios.get(config.apiUrl + 'graph/ketones/', {
      params: {
        fromDate: fromDate,
        toDate: toDate,
        user_id: userId
      },
      cancelToken: new self.CancelToken(function executor(c) {
        self.Cancel = c;
      })
    })
  },
  /**
   *
   * @param fromDate
   * @param toDate
   * @param userId
   * @param type
   * @returns {AxiosPromise}
   */
  getNutritionGraph: function (fromDate, toDate, userId, type = "calories") {
    let self = this;
    return axios.get(config.apiUrl + 'graph/nutrition/', {
      params: {
        fromDate: fromDate,
        toDate: toDate,
        user_id: userId,
        type: type
      },
      cancelToken: new self.CancelToken(function executor(c) {
        self.Cancel = c;
      })
    })
  }
};

export default GraphApi;



// WEBPACK FOOTER //
// ./src/api/Graphs/index.js